module.exports = __webpack_public_path__ + "img/9c388cb2a4ff6af71fa7e88978b7d4bf.png";